const SafePal = ({ ...props }) => (
  <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' {...props}>
    <rect width='24' height='24' rx='12' fill='#4A21EF' />
    <path
      d='M11.1721 5.27997C10.763 5.27997 10.3707 5.44246 10.0815 5.73171L5.53815 10.2751C5.36607 10.4472 5.28003 10.6728 5.28003 10.8983C5.28003 11.1239 5.36607 11.3494 5.53816 11.5215L8.51555 14.4989V9.22782C8.51555 8.83444 8.83194 8.51555 9.22531 8.51555C10.8872 8.51555 14.9326 8.51555 15.4844 8.51555L18.7199 5.28001L11.1721 5.27997Z'
      fill='white'
    />
    <path
      d='M8.51569 15.4844H14.7722C15.1656 15.4844 15.4845 15.1655 15.4845 14.7721V9.501L18.4619 12.4784C18.634 12.6505 18.72 12.8761 18.72 13.1016C18.72 13.3272 18.634 13.5527 18.4619 13.7248L13.9186 18.2682C13.6293 18.5575 13.237 18.72 12.828 18.72L5.28017 18.7199L8.51569 15.4844Z'
      fill='white'
    />
  </svg>
);

export default SafePal;
